/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListEquipmentQueryResponse, ListEquipmentPathParams, ListEquipmentQueryParams, ListEquipment400, ListEquipment401, ListEquipment403, ListEquipment404, ListEquipment409, ListEquipment500 } from "../../types/equipmentController/ListEquipment.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listEquipment } from "../../client/equipmentController/listEquipment.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listEquipmentQueryKey = (organizationId: ListEquipmentPathParams["organizationId"] | undefined, params?: ListEquipmentQueryParams) => [{ url: '/api/organizations/:organizationId/equipment/', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListEquipmentQueryKey = ReturnType<typeof listEquipmentQueryKey>

export function listEquipmentQueryOptions(organizationId: ListEquipmentPathParams["organizationId"] | undefined, params?: ListEquipmentQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listEquipmentQueryKey(organizationId, params)
        return queryOptions<ListEquipmentQueryResponse, ResponseErrorConfig<ListEquipment400 | ListEquipment401 | ListEquipment403 | ListEquipment404 | ListEquipment409 | ListEquipment500>, ListEquipmentQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listEquipment(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List equipment
 * {@link /api/organizations/:organizationId/equipment/}
 */
export function useListEquipment<TData = ListEquipmentQueryResponse, TQueryData = ListEquipmentQueryResponse, TQueryKey extends QueryKey = ListEquipmentQueryKey>(organizationId: ListEquipmentPathParams["organizationId"] | undefined, params?: ListEquipmentQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListEquipmentQueryResponse, ResponseErrorConfig<ListEquipment400 | ListEquipment401 | ListEquipment403 | ListEquipment404 | ListEquipment409 | ListEquipment500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listEquipmentQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listEquipmentQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListEquipment400 | ListEquipment401 | ListEquipment403 | ListEquipment404 | ListEquipment409 | ListEquipment500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}